import { BaseDto } from './base.dto';
import { ConfigurationDataTypeDto } from './configurationDataType.dto';
export class ConfigurationTypeDto extends BaseDto{
   
    name: string;
    
    description?: string;

    dataType?: ConfigurationDataTypeDto;
}